import { API_ORIGIN, apiUrl } from "./apiOrigin";
const API = apiUrl("");
export async function usageReviewRequest(path, body, signal) {
  const r = await fetch(`${API}/${path}`, {
    method: 'POST',
    signal,
    headers: {
      'Content-Type': 'application/json',
      Authorization: `Bearer ${localStorage.getItem('authToken')}`
    },
    body: JSON.stringify(body)
  });
  const text = await r.text();
  let data;
  try {
    data = JSON.parse(text);
  } catch (_) {
    throw new Error(r.status === 401 || r.status === 403 ? 'Your session was rejected. Sign in again and retry.' : `The server returned a web page instead of usage data (HTTP ${r.status}). Check the backend deployment and API routing.`);
  }
  if (!r.ok) throw new Error(data.error || `Request failed (HTTP ${r.status})`);
  return data;
}
// Reuse the established paired-usage route, so this search also works on
// servers which have not mounted the newer manual-review endpoints.
export async function searchBranchUsage({
  groupId,
  pharmacyId,
  search
}, signal, now = new Date()) {
  const months = [3, 2, 1].map(back => {
    const d = new Date(Date.UTC(now.getUTCFullYear(), now.getUTCMonth() - back, 1));
    return `${d.getUTCFullYear()}${String(d.getUTCMonth() + 1).padStart(2, '0')}`;
  });
  const results = [],
    covered = new Set();
  let truncated = false;
  for (let page = 0; page < 10; page++) {
    const data = await usageReviewRequest('usagePairGrid', {
      groupId,
      pharmacyId,
      search,
      side: 'prescribed',
      relationship: 'both',
      aggregate: false,
      page
    }, signal);
    for (const row of data.rows || []) {
      if (String(row.pharmacyId) !== String(pharmacyId)) continue;
      for (const m of row.months || []) if (months.includes(m.month) && m.units != null) covered.add(m.month);
      const children = row.children || [];
      for (const m of row.months || []) {
        if (!months.includes(m.month) || m.units == null) continue;
        const ownChildren = children.filter(c => c.months?.some(x => x.month === m.month && x.units > 0));
        if (ownChildren.length) for (const c of ownChildren) {
          const cm = c.months.find(x => x.month === m.month);
          results.push({
            month: m.month,
            prescribed: row.name,
            dispensed: c.name || c.core || '',
            prescribedQty: ownChildren.length === 1 ? m.units : null,
            dispensedQty: cm.units
          });
        } else if (m.units > 0) results.push({
          month: m.month,
          prescribed: row.name,
          dispensed: '',
          prescribedQty: m.units,
          dispensedQty: null
        });
      }
    }
    if ((page + 1) * (data.pageSize || 100) >= (data.total || 0)) break;
    if (page === 9) truncated = true;
  }
  return {
    months,
    coveredMonths: covered.size ? [...covered].sort() : null,
    items: results,
    truncated
  };
}
